import React from "react";
import {
  NavLink,
  Outlet,
  useOutletContext,
  useLocation,
} from "react-router-dom";

function Reports() {
  const { setGlobalLoading, token } = useOutletContext();
  const location = useLocation();

  return (
    <>
      <style>
        {`
        .nav-item.dropdown {
            position: relative;
            z-index: 100;
          }
        .nav-item.dropdown:hover .dropdown-menu {
            display: block;
            margin-top: 0;
          }

        .nav-item.dropdown .dropdown-menu {
            display: none;
            z-index: 120 !important;
          }
        `}
      </style>

      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Reports</h2>
          </div>
        </div>

        <ul className="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-2">

          {/* Revenue */}
          <li className="nav-item dropdown">
            <a
              className={`nav-link dropdown-toggle ${
                location.pathname.includes("/report/revenue")
                  ? "active"
                  : ""
              }`}
              data-bs-toggle="dropdown"
              href="javascript:void(0);"
            >
              <i className="ti ti-coin-rupee me-1"></i>
              Revenue
            </a>

            <ul className="dropdown-menu">
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="revenue_analysis"
                >
                  Revenue Analysis
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="revenue_netadd"
                >
                  Revenue Net Add
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Sector */}
          <li className="nav-item dropdown">
            <a
              className={`nav-link dropdown-toggle ${
                location.pathname.includes("/report/sector")
                  ? "active"
                  : ""
              }`}
              data-bs-toggle="dropdown"
              href="javascript:void(0);"
            >
              <i className="ti ti-chart-histogram me-1"></i>
              Sector Analysis
            </a>

            <ul className="dropdown-menu">
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="sector_report"
                >
                  Sector Report
                </NavLink>
              </li>

              {[1, 2, 3, 4, 5, 7, 9].map((id) => {
                const labels = {
                  1: "BFSI/PE",
                  2: "Infrastructure",
                  3: "Consumer",
                  4: "Communication",
                  5: "Technology",
                  7: "Healthcare",
                  9: "Others",
                };

                return (
                  <li key={id}>
                    <NavLink
                      className={({ isActive }) =>
                        `dropdown-item ${isActive ? "active" : ""}`
                      }
                      to={`sector_analysis/${id}`}
                    >
                      {labels[id]}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </li>

          {/* Region */}
          <li className="nav-item dropdown">
            <a
              className={`nav-link dropdown-toggle ${
                location.pathname.includes("/report/region")
                  ? "active"
                  : ""
              }`}
              data-bs-toggle="dropdown"
              href="javascript:void(0);"
            >
              <i className="ti ti-chart-area-line me-1"></i>
              Region Analysis
            </a>

            <ul className="dropdown-menu">
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="region_report"
                >
                  Region Report
                </NavLink>
              </li>
              {[81, 82, 83, 84, 85, 86, 87].map((id) => {
                const labels = {
                  81: "Europe",
                  82: "MEA",
                  83: "India",
                  84: "North Asia",
                  85: "SEA",
                  86: "Americas",
                  87: "ANZ",
                };

                return (
                  <li key={id}>
                    <NavLink
                      className={({ isActive }) =>
                        `dropdown-item ${isActive ? "active" : ""}`
                      }
                      to={`region_analysis/${id}`}
                    >
                      {labels[id]}
                    </NavLink>
                  </li>
                );
              })}     
            </ul>
          </li>

          {/* Other Tabs */}
          <li className="nav-item">
            <NavLink
              to="business_generation"
              className={({ isActive }) =>
                `nav-link dropdown-item ${isActive ? "active" : ""}`
              }
            >
              <i className="ti ti-briefcase me-1"></i>
              Business Generation
            </NavLink>
          </li>

          <li className="nav-item dropdown">
            <a
              className={`nav-link dropdown-toggle ${
                location.pathname.includes("/report/unit")
                  ? "active"
                  : ""
              }`}
              data-bs-toggle="dropdown"
              href="javascript:void(0);"
            >
              <i className="ti ti-world-dollar me-1"></i>
              Unit Performance
            </a>
            <ul className="dropdown-menu">
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="unit_performance"
                >
                  Performance
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="unit_vobt"
                >
                  Unit VOBT
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="unit_netadd"
                >
                  Unit Net Add
                </NavLink>
              </li> 
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="unit_changelog"
                >
                  Revenue Changes
                </NavLink>
              </li>   
            </ul>
          </li>

          <li className="nav-item dropdown">
            <a className={`nav-link dropdown-toggle ${
                location.pathname.includes("/report/client")
                  ? "active"
                  : ""
              }`}
              data-bs-toggle="dropdown"
              href="javascript:void(0);">
              <i className="ti ti-brand-comedy-central me-1"></i>
              Key Clients
            </a>
            <ul className="dropdown-menu">
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="client_account_analysis"
                >
                  Account Analysis
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="client_origin_analysis"
                >
                  Origin Analysis
                </NavLink>
              </li> 
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="client_quality"
                >
                  Client Quality
                </NavLink>
              </li>   
            </ul>
          </li>

          <li className="nav-item dropdown">
            <a className={`nav-link dropdown-toggle ${
                location.pathname.includes("/report/invoice")
                  ? "active"
                  : ""
              }`}
              data-bs-toggle="dropdown"
              href="javascript:void(0);">
              <i className="ti ti-report-search me-1"></i>
              Invoice Analysis
            </a>
            <ul className="dropdown-menu">
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="invoice_2nd_pending"
                >
                  2nd Ret Not in PINE
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="invoice_notissued"
                >
                  Not Issued
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="invoice_atrisk"
                >
                  Invoice At Risk
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="invoice_pipeline"
                >
                  Invoice Pipeline
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="invoice_outstanding"
                >
                  Outstanding
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="invoice_collection"
                >
                  Collection
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `dropdown-item ${isActive ? "active" : ""}`
                  }
                  to="invoice_canceled"
                >
                  Cancelled Invoice
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>

        <div className="row">
          <div className="col-xl-12">
            <Outlet context={{ setGlobalLoading, token }} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;